<template>
    <div class="hard-competences">
        <div class="grid">
            <div class="line"
                 v-for="(item, index) in getCompetenceKnowledge"
                 :key="index"
            ></div>
        </div>
        <div
            v-for="(item, index) in competences"
            :key="index"
            class="competence"
        >
            <HardCompetenceItem
                :competence="item"
            />
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';

const trackGetters = [
    'getCompetenceKnowledge',
];

import HardCompetenceItem from './HardCompetenceItem';

export default {
    name: 'HardCompetences',
    components: {
        HardCompetenceItem,
    },
    props: {
        competences: Array,
    },
    computed: {
        ...mapGetters('accountTrack', trackGetters),
    },
};
</script>

<style lang="scss" scoped>
    .hard-competences{
        display: flex;
        flex-direction: row;
        align-items: stretch;
        margin-top: 77px;
        position: relative;
        .competence{
            z-index: 2;
            margin-left: 55px;
            margin-right: 55px;
        }
        .grid{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            z-index: 1;
            .line{
                border-bottom: 1px solid #E3E9F0;
                margin-top: 23px;
                margin-bottom: 47px;

            }
        }
    }
</style>